import { render } from "./CertAlcoholActive.vue?vue&type=template&id=19c193e9&scoped=true"
import script from "./CertAlcoholActive.vue?vue&type=script&lang=js"
export * from "./CertAlcoholActive.vue?vue&type=script&lang=js"

import "./CertAlcoholActive.vue?vue&type=style&index=0&id=19c193e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c193e9"]])

export default __exports__